// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"712290aa","902":"0428cf2e"}[chunkId] + ".chunk.js";
};